(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker.Calendar",
                    {
                        url: "/Calendar",
                        component: "calendar",
                        PageTitle: "Calendar",
                        resolve: {
                            user: ["userApi", function (userApi) {
                                return userApi.getLoggedInUser().then(function (user) {
                                    return {
                                        UserId: user.Id,
                                        User: user
                                    };
                                });
                            }],
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }]
                        }
                    });
        }
    ]);

    app
        .component("calendar",
            {
                templateUrl: "App/Tools/MarketingTracker/Calendar/calendar-template.html",
                controller: calendarController,
                bindings: {
                    user: "<",
                    onBehalfOfUser: "<"
                }
            });

    calendarController.$inject = ["moment", "$scope", "$mdDialog", "uiCalendarConfig", "marketingTrackerAgentApi", "marketingPlanApi", "marketingTrackerApi", "marketingTrackerUserApi", "_", "$q", "marketingTrackerAuthService", "userApi", "marketingTrackerArcEventApi", "marketingTrackerEventTypeApi", "$window"];
    function calendarController(moment, $scope, $mdDialog, uiCalendarConfig, marketingTrackerAgentApi, marketingPlanApi, marketingTrackerApi, marketingTrackerUserApi, _, $q, marketingTrackerAuthService, userApi, marketingTrackerArcEventApi, marketingTrackerEventTypeApi, $window) {
        var $ctrl = this;
        window.c = this;
        ng.extend($ctrl,
            {
                getUserMarketingTrackerEventsForYear: getUserMarketingTrackerEventsForYear,
                universalCalendar: {
                    now: moment().toISOString(),
                    height: "parent",
                    handleWindowResize: true,
                    customButtons: {
                        myCustomButton: {
                            text: "year",
                            click: function () {
                                $ctrl.ui.calendarView = "year";
                                $scope.$apply();
                            }
                        }
                    },
                    header: {
                        left: "listDay,basicWeek,month,myCustomButton today ",
                        center: "title",
                        right: "prev,next"
                    },
                    buttonText: {
                        listDay: "day"
                    },
                    validRange: function (nowDate) {
                        return {
                            start: nowDate.startOf("year").toISOString(),
                            end: nowDate.endOf("year").toISOString()
                        };
                    },
                    eventClick: function (evt) {
                        return $mdDialog.show({
                            templateUrl: evt.eventType.Id === "FIG Event"
                                ? "App/Tools/MarketingTracker/Calendar/ViewFigEvent/viewfigevent-template.html"
                                : evt.event.IsPlanning
                                    ? "App/Tools/MarketingTracker/Calendar/EditPlanningEvent/editplanningevent-template.html"
                                    : "App/Tools/MarketingTracker/Calendar/EditEvent/editevent-template.html",
                            controller: evt.eventType.Id === "FIG Event" ? "viewFigEventController"
                                : evt.event.IsPlanning ? "editPlanningEventController"
                                    : "editEventController",
                            controllerAs: "$ctrl",
                            resolve: {
                                event: ["marketingTrackerEventApi", function (marketingTrackerEventApi) {
                                    if (evt.eventType.Id === "FIG Event")
                                        return evt.event;
                                    if (evt.eventType.IsAncillary)
                                        return marketingTrackerEventApi
                                            .getAncillaryEvent(evt.event.EventGroup.Id, evt.event.EventId);
                                    return marketingTrackerEventApi.getEvent(evt.event.EventGroup.Id, evt.event.EventId);
                                }],
                                eventGroup: ["marketingTrackerEventApi", function (marketingTrackerEventApi) {
                                    if (evt.eventType.Id === "FIG Event")
                                        return evt.eventGroup;
                                    if (evt.eventType.IsAncillary)
                                        return marketingTrackerEventApi.getAncillaryEventGroup(evt.event.EventGroup.Id);
                                    return marketingTrackerEventApi.getEventGroup(evt.event.EventGroup.Id);
                                }]
                            },
                            bindToController: true,
                            //clickOutsideToClose: true
                        }).then(function (response) {
                            if (response && response.eventGroupId && response.toDelete) {
                                var evGroupIndex = _.findIndex($ctrl.allMarketingTrackerEvents,
                                    function (row) {
                                        return row.EventGroup.Id === response.eventGroupId && row.EventId === response.eventId;
                                    });
                                if (evGroupIndex !== -1)
                                    $ctrl.allMarketingTrackerEvents.splice(evGroupIndex, 1);
                            }
                            else if (response && response.eventGroup) {
                                var evGroup = _.find($ctrl.allMarketingTrackerEvents,
                                    function (row) {
                                        return row.EventGroup.Id === response.eventGroup.Id &&
                                            row.EventId === response.event.Id;
                                    });
                                if (evGroup) {
                                    evGroup.EventDate = response.event.EventDate;
                                    evGroup.Title = response.eventGroup.EventType.Name === "Custom" ? response.event.Description : response.eventGroup.EventType.IsAncillary ? response.eventGroup.EventType.Name : response.event.Title;
                                }
                            }
                            convertFullCalendarEvents();
                            uiCalendarConfig.calendars[$ctrl.ui.currentCalendar].fullCalendar("removeEvents");
                            uiCalendarConfig.calendars[$ctrl.ui.currentCalendar].fullCalendar("addEventSource",
                                $ctrl.eventSource);
                        }).catch(function (e) {
                            error();
                        });
                    }
                },
                dayCalendar: {
                    defaultView: "listDay",
                    views: {
                        listDay: {
                            titleFormat: "dddd MMMM D, YYYY"
                        }
                    }
                },
                weekCalendar: {
                    defaultView: "basicWeek",
                },
                monthCalendar: {
                    defaultView: "month",
                    eventLimit: 4,
                    eventLimitClick: "popover"
                },
                yearCalendar: {
                    contextMenuItems: [
                        {
                            text: "Update",
                            subMenu: [],
                            click: function (evt) {
                                return $mdDialog.show({
                                    templateUrl: "App/Tools/MarketingTracker/Calendar/EditEvent/editevent-template.html",
                                    controller: "editEventController",
                                    controllerAs: "$ctrl",
                                    locals: {
                                        eventGroup: evt.eventGroup,
                                        event: evt.event
                                    },
                                    bindToController: true
                                }).then(function (response) {
                                    if (response && response.eventGroupId && response.toDelete) {
                                        var evGroupIndex = _.findIndex($ctrl.allMarketingTrackerEvents,
                                            function (row) {
                                                return row.EventGroup.Id === response.eventGroupId && row.EventId === response.eventId;
                                            });
                                        if (evGroupIndex !== -1)
                                            $ctrl.allMarketingTrackerEvents.splice(evGroupIndex, 1);
                                    }
                                    else if (response && response.eventGroup) {
                                        var evGroup = _.find($ctrl.allMarketingTrackerEvents,
                                            function (row) {
                                                return row.EventGroup.Id === response.eventGroup.Id &&
                                                    row.EventId === response.event.Id;
                                            });
                                        if (evGroup) {
                                            evGroup.EventDate = response.event.EventDate;
                                            //evGroup.Title = response.event.Title;
                                            evGroup.Title = response.eventGroup.EventType.Name === "Custom" ? response.event.Description : response.eventGroup.EventType.IsAncillary ? response.eventGroup.EventType.Name : response.event.Title;
                                        }
                                    }
                                    convertFullCalendarEvents();
                                });
                            }
                        }
                    ],
                    minDate: moment().startOf("year").toDate(),
                    maxDate: moment().endOf("year").toDate(),
                    clickDay: function (elem) {
                        $ctrl.ui.calendarView = "day";
                        $ctrl.dayCalendar.now = moment(elem.date).toISOString();
                        $scope.$apply();
                    }
                },
                ui: {
                    loading: true,
                    calendarView: "month",
                    selectedYear: moment().year(),
                    currentCalendar: "monthCalendar",
                    isCurrentYear: true,
                    CalSideNavIsOpen: false
                },
                years: [],
                eventSource: {
                    events: []
                },
                yearCalendarEvents: [],
                eventCounts: {},
                openAddEvent: openAddEvent,
                colorCodeEventTypes: colorCodeEventTypes,
                colorEvents: colorEvents,
                error: error,
                toggleCalSideNav: toggleCalSideNav
            });

        function toggleCalSideNav() {
            $ctrl.ui.CalSideNavIsOpen = !$ctrl.ui.CalSideNavIsOpen;
        }

        function error($event) {
            var errorMsg = $mdDialog.alert({
                title: "We're sorry, there was an error.",
                targetEvent: $event,
                ariaLabel: "Confirm event error",
                ok: "Yes",
                multiple: true,
                clickOutsideToClose: false
            });

            $mdDialog.show(errorMsg).then(function () {
                $mdDialog.hide({
                    eventGroup: $ctrl.eventGroup,
                    event: $ctrl.event
                });
                $window.location.reload();
            });
        }

        function colorCodeEventTypes() {
            $ctrl.eventTypes.forEach(function (e) {
                var hash = 0;
                for (var i = 0, len = e.Id.length; i < len; i++) {
                    var char = e.Id.charCodeAt(i);
                    hash = ((hash << 5) - hash) + char;
                    hash |= 0;
                }
                var color = {};
                color.a = Math.abs((hash & 0xff000000) >> 24);
                color.r = ((hash & 0x00ff0000) >> 16);
                color.g = ((hash & 0x0000ff00) >> 8);
                color.b = (hash & 0x000000ff);
                var opacity = 0.4; // + ((color.a / 255) / 10);
                e.textcolor = "#1e1e1e";
                e.colorstyle = "rgba(" + color.r + "," + color.g + "," + color.b + "," + opacity + ")";
            });
        }

        function colorEvents() {
            $ctrl.eventSource.events.forEach(function (e) {
                var event = $ctrl.eventTypes.find(function (t) {
                    return t.Id === e.eventType.Id;
                });
                e.color = event.colorstyle;
                e.textColor = event.textcolor;
            });
            $ctrl.yearCalendarEvents.forEach(function (e) {
                var event = $ctrl.eventTypes.find(function (t) {
                    return t.Id === e.eventType.Id;
                });
                e.color = event.colorstyle;
                e.textColor = event.textcolor;
            });
        }

        function openAddEvent(eventType) {
            if (eventType.Id === "FIG Event")
                return false;
            return $mdDialog.show({
                templateUrl: "App/Tools/MarketingTracker/Calendar/AddEvent/addevent-template.html",
                controller: "addEventController",
                controllerAs: "$ctrl",
                locals: {
                    eventType: eventType,
                    user: $ctrl.user,
                    selectedYear: $ctrl.ui.selectedYear
                },
                bindToController: true
            }).then(function (response) {
                console.log(response)
                if (response instanceof Array) {
                    ng.forEach(response,
                        function (evtGroup) {
                            ng.forEach(evtGroup.Events,
                                function (event) {
                                    $ctrl.eventSource.events.push({
                                        title: evtGroup.EventType.Name === "Custom"
                                            ? event.Description
                                            : evtGroup.EventType.IsAncillary
                                                ? evtGroup.EventType.Name
                                                : event.Title,
                                        //title: !!evtGroup.EventType.IsAncillary ? evtGroup.EventType.Name : event.Title,
                                        start: moment(event.EventDate).toISOString(),
                                        allDay: true
                                    });
                                    $ctrl.allMarketingTrackerEvents.push({
                                        EventGroup: evtGroup,
                                        //Title: !!evtGroup.EventType.IsAncillary ? evtGroup.EventType.Name : event.Title,
                                        Title: evtGroup.EventType.Name === "Custom"
                                            ? event.Description
                                            : evtGroup.EventType.IsAncillary
                                                ? evtGroup.EventType.Name
                                                : event.Title,
                                        EventDate: event.EventDate,
                                        EventType: evtGroup.EventType,
                                        EventId: event.Id,
                                        IsPlanning: event.IsPlanning
                                    });
                                });
                        });
                } else {
                    ng.forEach(response.Events,
                        function (event) {
                            $ctrl.eventSource.events.push({
                                //title: !!response.EventType.IsAncillary ? response.EventType.Name : event.Title,
                                title: response.EventType.Name === "Custom"
                                    ? event.Description
                                    : response.EventType.IsAncillary
                                        ? response.EventType.Name
                                        : event.Title,
                                start: moment(event.EventDate).toISOString(),
                                allDay: true
                            });
                            $ctrl.allMarketingTrackerEvents.push({
                                EventGroup: response,
                                //Title: !!response.EventType.IsAncillary ? response.EventType.Name : event.Title,
                                Title: response.EventType.Name === "Custom"
                                    ? event.Description
                                    : response.EventType.IsAncillary
                                        ? response.EventType.Name
                                        : event.Title,
                                EventDate: event.EventDate,
                                EventType: response.EventType,
                                EventId: event.Id,
                                IsPlanning: event.IsPlanning
                            })
                        });
                }

                convertFullCalendarEvents();
                calcEventCountsPerYear();
                uiCalendarConfig.calendars[$ctrl.ui.currentCalendar].fullCalendar("removeEvents");
                uiCalendarConfig.calendars[$ctrl.ui.currentCalendar].fullCalendar("addEventSource", $ctrl.eventSource);
            });
        }

        function roundDate(timeStamp) {
            timeStamp -= timeStamp % (24 * 60 * 60 * 1000); //subtract amount of time (in ms) since midnight              
            timeStamp += new Date(timeStamp).getTimezoneOffset() * 60 * 1000; //add on the timezone offset         
            return new Date(timeStamp);
        }

        function convertFullCalendarEvents() {
            $ctrl.eventSource.events = [];
            $ctrl.yearCalendarEvents = [];

            ng.forEach($ctrl.allMarketingTrackerEvents,
                function (eventGroup) {

                    //for older events not showing up in year calendar, the roundDate function brings the date to the correct hour mark to display in year calendar                  
                    if (new Date(eventGroup.EventDate).getHours() > 0) {
                        eventGroup.EventDate = roundDate(eventGroup.EventDate);
                    }

                    $ctrl.eventSource.events.push({
                        //title: !!eventGroup.EventType.IsAncillary ? eventGroup.EventType.Name : eventGroup.Title,
                        //title: eventGroup.Title,
                        title: (eventGroup.EventType.IsAncillary && eventGroup.IsPlanning && eventGroup.EventType.Name !== "Custom") ? "Planning - " + eventGroup.Title : eventGroup.Title,
                        start: moment(eventGroup.EventDate).toISOString(),
                        allDay: true,
                        eventGroup: eventGroup.EventGroup,
                        event: eventGroup,
                        eventType: eventGroup.EventType
                    });

                    $ctrl.yearCalendarEvents.push({
                        //name: !!eventGroup.EventType.IsAncillary ? eventGroup.EventType.Name : eventGroup.Title,
                        name: (eventGroup.EventType.IsAncillary && eventGroup.IsPlanning && eventGroup.EventType.Name !== "Custom") ? "Planning - " + eventGroup.Title : eventGroup.Title,
                        startDate: new Date(eventGroup.EventDate),
                        endDate: new Date(eventGroup.EventDate),
                        eventGroup: eventGroup.EventGroup,
                        event: eventGroup,
                        eventType: eventGroup.EventType
                    });
                });

            colorEvents();
        }

        function calcEventCountsPerYear() {
            $ctrl.eventCounts = [];

            ng.forEach($ctrl.eventTypes,
                function (t) {
                    $ctrl.eventCounts[t.Name] = _.uniqBy(_.filter($ctrl.allMarketingTrackerEvents,
                        function (row) {
                            return row.EventType.Id === t.Id && !row.IsPlanning;
                        }), function (row) { return row.EventGroup.Id; }).length;
                });
        }

        function getRecommendations() {
            return marketingTrackerAgentApi.get().catch(ng.noop).then(function (agent) {
                return marketingPlanApi
                    .getMarketingPlanByYear(agent.AgentId, $ctrl.ui.selectedYear).then(function (plan) {
                        return $ctrl.recommendations = plan.Recommendations;
                    }, function () {
                        return $ctrl.recommendations = [];
                    });
            });
        }

        function getMarketingTrackerFigAuthUserEvents(figAuthUserId, year, month, nextPageToken) {
            return marketingTrackerUserApi.getFigAuthUserBasicEventsByDate(figAuthUserId, year, month, nextPageToken)
                .then(function (events) {
                    if (!events.NextPage) return events;
                    return getMarketingTrackerFigAuthUserEvents(figAuthUserId, year, month, events.NextPage)
                        .then(function (recursiveEvents) {
                            return events = _.concat(events, recursiveEvents);
                        });
                });
        }
        function getMarketingTrackerFigAuthUserAncillaryEvents(figAuthUserId, year, month, nextPageToken) {
            return marketingTrackerUserApi.getFigAuthUserBasicAncillaryEventsByDate(figAuthUserId, year, month, nextPageToken)
                .then(function (events) {
                    if (!events.NextPage) return events;
                    return getMarketingTrackerFigAuthUserAncillaryEvents(figAuthUserId, year, month, events.NextPage)
                        .then(function (recursiveEvents) {
                            return events = _.concat(events, recursiveEvents);
                        });
                });
        }

        function getMarketingTrackerEventsForFigAuthUser(figAuthUserId, year, month) {
            var p1 = getMarketingTrackerFigAuthUserEvents(figAuthUserId, year, month);
            var p2 = getMarketingTrackerFigAuthUserAncillaryEvents(figAuthUserId, year, month);
            return $q.all([p1, p2]).then(function (results) {
                var events = [];
                ng.forEach(results,
                    function (r) {
                        events = _.concat(events, r);
                    });
                return events;
            });
        }

        function getUserMarketingTrackerEventsForYear() {
            $ctrl.allMarketingTrackerEvents = [];
            var promises = [];

            if ($ctrl.ui.selectedYear === (new Date()).getFullYear()) {
                $ctrl.dayCalendar.now = moment(new Date());
                $ctrl.weekCalendar.now = moment(new Date());
                $ctrl.monthCalendar.now = moment(new Date());
            } else {
                $ctrl.dayCalendar.now = moment(new Date($ctrl.ui.selectedYear, 1)).startOf("year");
                $ctrl.weekCalendar.now = moment(new Date($ctrl.ui.selectedYear, 1)).startOf("year");
                $ctrl.monthCalendar.now = moment(new Date($ctrl.ui.selectedYear, 1)).startOf("year");
            }

            $ctrl.yearCalendar.minDate = moment(new Date($ctrl.ui.selectedYear, 1)).startOf("year").toDate();
            $ctrl.yearCalendar.maxDate = moment(new Date($ctrl.ui.selectedYear, 1)).endOf("year").toDate();

            promises.push(marketingTrackerApi.getToken($ctrl.user.UserId).then(function (token) {
                marketingTrackerAuthService.setAccessToken(token);
                return userApi.getFigAuth($ctrl.ui.selectedUser.UserId).then(function (figAuthUser) {
                    var subPromises = [];
                    for (var i = 1; i <= 12; i++)
                        subPromises.push(getMarketingTrackerEventsForFigAuthUser(figAuthUser.FigAuthUserId, $ctrl.ui.selectedYear, i)
                            .then(function (events) {
                                $ctrl.allMarketingTrackerEvents = $ctrl.allMarketingTrackerEvents
                                    .concat(events);
                            }));
                    return $q.all(subPromises);
                });
            }));
            promises.push(marketingTrackerArcEventApi.getArcEvents().catch(ng.noop).then(function (events) {
                events = events || [];
                var data = [];
                ng.forEach(events,
                    function (event) {
                        data.push({
                            EventGroup: {
                                TypeId: "FIG Event",
                                EventType: {
                                    Name: "FIG Event",
                                    Id: "FIG Event"
                                }
                            },
                            Title: event.Title,
                            Location: event.Location,
                            EventDate: event.EventDate,
                            EventType: {
                                Name: "FIG Event",
                                Id: "FIG Event"
                            }
                        });
                    });
                return $ctrl.allMarketingTrackerEvents = $ctrl.allMarketingTrackerEvents.concat(data);
            }));
            promises.push(getRecommendations());
            $q.all(promises).then(function () {
                colorCodeEventTypes();
                convertFullCalendarEvents();
                calcEventCountsPerYear();
                uiCalendarConfig.calendars[$ctrl.ui.currentCalendar].fullCalendar("removeEvents");
                uiCalendarConfig.calendars[$ctrl.ui.currentCalendar].fullCalendar("addEventSource", $ctrl.eventSource);
                uiCalendarConfig.calendars[$ctrl.ui.currentCalendar].fullCalendar("render");
                $ctrl.ui.loading = false;
            }).then(function () { $ctrl.ui.loading = false; });
        }

        function init() {
            $ctrl.ui.loading = true;
            marketingTrackerApi.getToken($ctrl.user.UserId).then(function (token) {
                marketingTrackerAuthService.setAccessToken(token);
                $ctrl.ui.selectedUser = $ctrl.user;
                if ($ctrl.onBehalfOfUser) {
                    $ctrl.ui.selectedUser = {
                        UserId: $ctrl.onBehalfOfUser.Id,
                        User: $ctrl.onBehalfOfUser
                    };
                }
                userApi.getFigAuth($ctrl.ui.selectedUser.UserId).then(function (figAuthUser) {
                    marketingTrackerAgentApi.getForFigAuth(figAuthUser.FigAuthUserId).then(function (agent) {

                        ng.extend($ctrl.dayCalendar, $ctrl.universalCalendar);
                        ng.extend($ctrl.weekCalendar, $ctrl.universalCalendar);
                        ng.extend($ctrl.monthCalendar, $ctrl.universalCalendar);
                        for (var i = 2015; i <= $ctrl.ui.selectedYear + 2; i++)
                            if (!_.find($ctrl.years, function (row) { return row === i; }))
                                $ctrl.years.push(i);

                        $ctrl.ui.selectedYear = (new Date()).getFullYear();

                        marketingTrackerEventTypeApi.getEventTypesForUser(agent.UserId).then(function (types) {
                            $ctrl.eventTypes = types;
                            $ctrl.eventTypes.push({
                                Name: "FIG Event",
                                Id: "FIG Event"
                            });
                            getUserMarketingTrackerEventsForYear();
                        });
                    });
                });
            });
        }

        init();
    }

})(window.app, window.angular); //jshint ignore:line